import React, { useState, useEffect, useRef } from 'react';
import NavBar from '../../components/NavBarSearchSong';
import Settings from '../../assets/Settings.png';
import RoundButton from '../../components/RoundButton';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Delete from '../../assets/Delete.png';
import './PlaylistDetails.scss';
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';
import { useParams, useHistory } from 'react-router-dom';
import { _showAlert, formatDateToDisplay } from '../../utils';
import { Button } from '../../components';
import UploadImageSvg from './UpalodImageSvg';
import { CircularProgress } from '@material-ui/core';
import { playlistActions, songActions } from '../../actions';
import PlayListThumbnail from '../../components/PlayListThumbnail';
import Popup from '../../components/Popup';
import Grid from '@material-ui/core/Grid';
import SongPlayer from '../../components/SongPlayer';
import useClickOutside from '../../utils/useClickOutside';

// Images
import PlayBtn from '../../assets/play_btn.svg';

/* 
Table Data and Use Style
*/
const useStyles = makeStyles({
  table: {
    minWidth: 700,
    borderRadius: 30,
  },
});

const SortableItem = SortableElement(({ index, indexNumber, row, handleRemoveSong, isSongPlaying, setIsSongPlaying }) => {
  const [isSongDialogOpen, setIsSongDialogOpen] = useState(false);
  const [songDetail, setSongDetail] = useState({});

  const toolTipRef = useRef(null);
  useClickOutside(toolTipRef, () => {
    setIsSongDialogOpen(false);
  });

  const toolTipRefs = useRef(null);
  const onPlayClick = (song, index) => {
    setSongDetail({
      song_name: song.title || '',
      artist_name: song.artist_name || '',
      songgenre: song.genre || [],
      description: song.description || '',
      thumbnail_img: song.thumbnail_img || '',
      license: song.license_name || '',
      termsandconditions: song.tc_sign || '',
      created_by: song.created_by || '',
      creator_id: song.creator_id || '',
      plan: song.plan || [],
      audio_track: song.audio_track || '',
    });

    setIsSongDialogOpen({
      id: index,
      isOpen: true,
    });
  };

  return (
    <>
      <TableRow>
        <TableCell className="result-with-image">
          <div style={{ display: 'flex', columnGap: 30, alignItems: 'center' }}>
            <span>{indexNumber + 1}.</span>
            <PlayListThumbnail src={row.thumbnail_img} name={row.title} style={{ borderRadius: 6 }} />
          </div>
        </TableCell>
        <TableCell>{formatDateToDisplay(row.created_at)}</TableCell>
        <TableCell>{row.title || 'N/A'}</TableCell>
        <TableCell className="action">
          <div style={{ height: '100%', width: '60px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            {/* <img
              src={PlayBtn}
              onClick={() => {
                onPlayClick(row.id);
              }}
              alt=""
            /> */}

            <Grid item ref={toolTipRefs?.current?.[index]} className="tooltip-wrapper">
              <img
                src={PlayBtn}
                onClick={() => {
                  onPlayClick(row, index);
                }}
                alt=""
              />
              {isSongDialogOpen.isOpen && isSongDialogOpen.id === index && (
                <SongPlayer
                  songDetail={songDetail}
                  onClose={() => {
                    setIsSongDialogOpen({
                      id: 0,
                      isOpen: false,
                    });
                  }}
                />
              )}
            </Grid>

            <img alt="" style={{ height: '21px', width: '21px', objectFit: 'contain' }} src={Delete} onClick={handleRemoveSong(row.id)} />
          </div>
          {/* 
          {isSongDialogOpen && (
            <div className="">
              <Grid item ref={toolTipRef} className="tooltip-wrapper">
                {isSongDialogOpen && <SongPlayer songDetail={songDetail} onClose={() => setIsSongDialogOpen(false)} />}
              </Grid>
            </div>
          )} */}
        </TableCell>
      </TableRow>
    </>
  );
});

const SortableList = SortableContainer(({ items = [], isChangeOrder, handleRemoveSong, onPlaySong, isSongLoading }) => {
  return (
    <TableBody>
      {isSongLoading && (
        <div className="table_initial_loader">
          <CircularProgress />
        </div>
      )}
      {items.map((row, index) => (
        <SortableItem
          onPlaySong={onPlaySong}
          handleRemoveSong={handleRemoveSong}
          disabled={isChangeOrder}
          key={`item-${index}`}
          indexNumber={index}
          index={index}
          row={row}
          isSongLoading={isSongLoading}
        />
      ))}
    </TableBody>
  );
});

function PlaylistDetails(props) {
  const history = useHistory();
  const params = useParams();
  const imageInputRef = useRef(null);

  const [playlistDetails, setPlaylistDetails] = useState({});
  const [name, setName] = useState('');
  const [playlistSongs, setPlaylistSongs] = useState([]);
  const [isChangeOrder, setChangeOrder] = useState(false);
  const [isEditPopUpOpen, setIsEditPopUpOpen] = useState(false);
  const [isDraggableView, setIsDraggableView] = useState(false);
  const [imageUploadedFromPc, setImageUpaloadedFromPc] = useState('');
  const [image, setImage] = useState(null);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);

  const [deletePopup, setDeletePopup] = useState({ isOpen: false, id: null });
  const [confirmPopUp, setConfirmPopUp] = useState({ isOpen: false, id: null });
  const [confirmLoading, setConfirmLoading] = useState(false);

  const handleAddNewSongs = () => {
    history.push({
      pathname: `/${playlistDetails?.type.toLowerCase()}-playlist/${params?.playlistId}/add-songs`,
      state: { playlistDetails },
    });
  };

  const handleSortByDate = () => {
    let sortedItems = playlistSongs.sort(function (a, b) {
      return new Date(a.created_at) - new Date(b.created_at);
    });
    setPlaylistSongs([...sortedItems]);
  };

  const handleShuffle = () => {
    var currentIndex = playlistSongs.length,
      randomIndex;
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
      // And swap it with the current element.
      [playlistSongs[currentIndex], playlistSongs[randomIndex]] = [playlistSongs[randomIndex], playlistSongs[currentIndex]];
    }
    setPlaylistSongs([...playlistSongs]);
  };

  const handleUpdateImageClick = () => {
    setIsEditPopUpOpen(true);
    if (!playlistDetails?.thumbnail_img) {
      setIsDraggableView(true);
    }
  };

  const convertImageToUrl = (file) => {
    setImage(file);
    setImageUpaloadedFromPc(URL.createObjectURL(file));
  };

  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
    } else if (e.type === 'dragleave') {
    }
  };

  // triggers when file is dropped
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const type = e?.dataTransfer?.files?.[0]?.type;
      if (type === 'image/jpg' || type === 'image/png' || type === 'image/jpeg') {
        convertImageToUrl(e.dataTransfer.files[0]);
        setIsDraggableView(false);
      }
    }
  };

  const uploadImage = async () => {
    if (!image) {
      _showAlert('Please select image to upload', 'error');
      return;
    }
    try {
      setIsImageUploading(true);

      const uploadImageRes = await playlistActions.uploadPlaylistImage(playlistDetails.id, image);
      if (uploadImageRes?.code === 201 || uploadImageRes?.code === 'CREATED_SUCCESSFULLY') {
        setIsImageUploading(false);
        setIsEditPopUpOpen(false);
        _showAlert('Playlist image updated successfully', 'success');
      } else {
        _showAlert('Something went wrong', 'error');
        setIsImageUploading(false);
        setIsEditPopUpOpen(false);
      }
    } catch (error) {
      _showAlert(error.message, 'error');
      setIsImageUploading(false);
      setIsEditPopUpOpen(false);
    }
  };

  const fetchPlaylistById = async () => {
    const fetchPlaylistByIdRes = await playlistActions.fetchPlaylistById(params?.playlistId);
    setPlaylistDetails(fetchPlaylistByIdRes?.data);
  };

  // Handle Delete Song
  const handleSongDelete = async () => {
    setConfirmLoading(true);
    const deleteSong = playlistSongs?.filter((item) => item.id !== deletePopup?.id).map((item, index) => item.id);
    const updatePlaylistRes = await playlistActions.updatePlaylist(playlistDetails?.id, { songs: deleteSong });

    if (updatePlaylistRes?.code === 'OK') {
      setConfirmLoading(false);
      setDeletePopup({ isOpen: false, id: null });
      _showAlert('Song deleted successfully', 'success');
      setPlaylistSongs(playlistSongs?.filter((item) => item.id !== deletePopup?.id));
    } else {
      setConfirmLoading(false);
      setDeletePopup({ isOpen: false, id: null });
      _showAlert('Something went wrong', 'error');
    }
  };

  const handleDeleteConfirmModal = (id) => () => {
    setDeletePopup({ isOpen: true, id });
  };

  const handleSave = async () => {
    setConfirmLoading(true);
    const updatePlaylistRes = await playlistActions.updatePlaylist(params?.playlistId, {
      name,
      songs: playlistSongs?.map((item) => item.id),
    });
    if (updatePlaylistRes.code === 'OK') {
      setConfirmPopUp({ isOpen: false, id: null });
      setConfirmLoading(false);
      _showAlert('Playlist updated successfully', 'success');
      history.push(playlistDetails?.type === 'UNLIMITED' ? '/unlimited-playlist' : '/radio-playlist');
    }
  };

  useEffect(() => {
    (async () => {
      setTableLoading(true);
      if (params?.playlistId) {
        await fetchPlaylistById();
      }
      setTableLoading(false);
    })();
  }, []);

  useEffect(() => {
    setLoading(true);
    if (playlistDetails) {
      setName(playlistDetails.name ? playlistDetails.name : '');
      setImageUpaloadedFromPc(`${process.env.REACT_APP_MEDIA_URL}/${playlistDetails?.thumbnail_img}`);
      setPlaylistSongs(playlistDetails?.songs);
    }
    setLoading(false);
  }, [playlistDetails]);

  return (
    <div className="edit-playlist-secondery" style={{ width: '100%' }}>
      {isEditPopUpOpen && (
        <div className="backDrop" onClick={() => setIsEditPopUpOpen(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <p className="headerText">Upload Image</p>
            <div className="contentContainer">
              {isDraggableView ? (
                <>
                  <form
                    id="form-file-upload"
                    style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '20px' }}
                    onDragEnter={handleDrag}
                    onSubmit={(e) => e.preventDefault()}
                  >
                    <div
                      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                      onDragEnter={handleDrag}
                      onDragLeave={handleDrag}
                      onDragOver={handleDrag}
                      onDrop={handleDrop}
                    >
                      <UploadImageSvg />
                      <p className="dragContent">Drag & Drop or Browse the files from your computer (only Jpeg and PNG)</p>
                    </div>
                    <RoundButton btnText="Select" className="modal_btn" handleClick={() => imageInputRef.current.click()} />
                    <input
                      type="file"
                      style={{ display: 'none' }}
                      ref={imageInputRef}
                      onChange={(e) => {
                        convertImageToUrl(e.target.files[0]);
                        setIsDraggableView(false);
                      }}
                      accept="image/jpg, image/png, image/jpeg"
                    />
                  </form>
                </>
              ) : (
                <div style={{ flex: 1, width: '100%', display: 'flex', flexDirection: 'column' }}>
                  <div className="imageContainer">
                    <img style={{ height: '120px', width: '120px', objectFit: 'contain' }} src={imageUploadedFromPc} alt="alt" />
                  </div>
                  <div className="btnContainer">
                    {isImageUploading ? (
                      <CircularProgress />
                    ) : (
                      <>
                        <RoundButton className="modal_btn white_btn" btnText="Change" handleClick={() => setIsDraggableView(true)} />
                        <RoundButton className="modal_btn" btnText="Confirm" handleClick={uploadImage} />
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      <NavBar
        data="Edit Playlist"
        icon={Settings}
        currentRouteName={playlistDetails?.name}
        breadcrumbsPath={[
          { name: 'Playlist' },
          playlistDetails?.type === 'UNLIMITED'
            ? { name: 'Unlimited-playlist', link: '/unlimited-playlist' }
            : { name: 'Radio-playlist', link: '/radio-playlist' },
        ]}
      />
      <div className="tblUpperRow">
        <input value={name} name="name" className="readonly-input" onChange={(event) => setName(event.target.value)} />
        <div className="grp_btn">
          <RoundButton btnText="Update Image" handleClick={handleUpdateImageClick} />
          <RoundButton btnText="Sort by date" handleClick={handleSortByDate} />
          <RoundButton
            className={isChangeOrder && 'disabled-button'}
            btnText="Change order list"
            handleClick={() => setChangeOrder(!isChangeOrder)}
          />
          <RoundButton btnText="Shuffle" handleClick={handleShuffle} />
          <RoundButton btnText="Add Songs" handleClick={handleAddNewSongs} />
        </div>
      </div>

      <div style={{ flex: 1, overflow: 'hidden', paddingBottom: 50, width: '100%' }}>
        <div style={{ height: '100%' }}>
          <TableContainer className="tbl_wraper" style={{ height: '100%' }} component={Paper}>
            <Table className={useStyles.table} stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell className="result-with-image">Result</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Playlist Name</TableCell>
                  <TableCell className="action">Action</TableCell>
                </TableRow>
              </TableHead>
              <SortableList
                handleRemoveSong={handleDeleteConfirmModal}
                isChangeOrder={!isChangeOrder}
                isSongLoading={tableLoading}
                items={playlistSongs}
                onSortEnd={({ oldIndex, newIndex }) => {
                  setPlaylistSongs(arrayMove(playlistSongs, oldIndex, newIndex));
                }}
                pressDelay={200}
              />
            </Table>
          </TableContainer>
        </div>
      </div>

      <Button
        onClick={handleSave}
        isLoading={confirmLoading}
        className="round_btn"
        style={{ display: 'inline-block', width: 'auto', marginLeft: 'auto', marginBottom: 20 }}
      >
        Save
      </Button>

      <Popup open={deletePopup?.isOpen} onClose={() => !confirmLoading && setDeletePopup({ isOpen: false, id: null })}>
        <h4 style={{ textAlign: 'center', marginBottom: 20, fontSize: 20, lineHeight: '32px', maxWidth: '60%', marginInline: 'auto' }}>
          Are you sure, you want to delete this song from the playlist?
        </h4>
        <div className="button-group" style={{ '--button-color': '#6900af' }}>
          <Button onClick={() => !confirmLoading && setDeletePopup({ isOpen: false, id: null })} className="button transparent">
            Cancel
          </Button>

          <Button isLoading={confirmLoading} onClick={handleSongDelete} className="button primary">
            Confirm
          </Button>
        </div>
      </Popup>

      <Popup open={confirmPopUp?.isOpen} onClose={() => !confirmLoading && setConfirmPopUp({ isOpen: false, id: null })}>
        <h4 style={{ textAlign: 'center', marginBottom: 20, fontSize: 20, lineHeight: '32px', maxWidth: '60%', marginInline: 'auto' }}>
          Are you sure, you want to save?
        </h4>
        <div className="button-group" style={{ '--button-color': '#6900af' }}>
          <Button onClick={() => !confirmLoading && setConfirmPopUp({ isOpen: false, id: null })} className="button transparent">
            Cancel
          </Button>

          <Button isLoading={confirmLoading} onClick={handleSave} className="button primary">
            Confirm
          </Button>
        </div>
      </Popup>
    </div>
  );
}

export default PlaylistDetails;

